import { BindOptionsBaseV2, CreateFormUrl, Currency } from '../types';
import { TrustApiError } from '../errors';
import { ApplePayPreset, GooglePayPreset, BindingFlow, LinkTarget } from '@payments-frontend/shared';

export interface CreateVerificationIntentParams extends BindOptionsBaseV2 {
    flow: BindingFlow;

    currency?: Currency;

    applePayPreset?: `${ApplePayPreset}`;
    googlePayPreset?: `${GooglePayPreset}`;

    linkTarget?: LinkTarget;
    termUrl?: string;
}

export const createVerificationIntent = async (apiHost: string, params: CreateVerificationIntentParams) => {
    const response = await fetch(`${apiHost}/web/create_verification_intent?service_token=${params.serviceToken}`, {
        method: 'post',
        headers: new Headers({
            'Content-Type': 'application/json',
        }),
        body: JSON.stringify({
            currency: params.currency,
            form_params: {
                integrationProfileId: params.integrationProfileId,

                mode: params.mode,

                flow: params.flow,

                apple_pay_preset: params.applePayPreset,
                google_pay_preset: params.googlePayPreset,

                link_target: params.linkTarget,
                term_url: params.termUrl,

                query_params: {
                    theme: params.theme,
                    lang: params.lang,
                    layout: params.layout,
                },
            },
        }),
        credentials: 'include',
    });

    if (!response.ok) {
        throw new TrustApiError(`${response.status} server error`);
    }

    const json: CreateFormUrl = await response.json();

    return json.form_url;
};
